export default __webpack_public_path__ + "static/media/github.e2f5b3f3.png";